var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-examples",
    transform: "translate(-298.000000, -1186.000000)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter-menu-example-copy-2",
    transform: "translate(282.000000, 1068.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,120 L32,134 L18,134 L18,120 L32,120 L32,120 Z M32,118 L18,118 C16.9,118 16,118.9 16,120 L16,134 C16,135.1 16.9,136 18,136 L32,136 C33.1,136 34,135.1 34,134 L34,120 C34,118.9 33.1,118 32,118 L32,118 L32,118 Z",
    id: "off"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxEmpty);
export default __webpack_public_path__ + "static/media/checkboxEmpty.e53e299a275ea4f6529f31a8f0fb5820.svg";
export { ForwardRef as ReactComponent };